<div class="take-test-container" fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="18px">
	<div class="take-test-block" fxLayout="column" fxFlex="1 1" fxLayoutAlign="space-between stretch" fxLayoutGap="36px">
		<div class="test-body-block" fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch">
			<loader [loader]="sectionLoader" [type]="'general'">
			</loader>
			<!-- <ng-container *ngIf="action === 'testStart' && testData"> -->
			<div class="take-test-header" fxLayout="column" fxLayoutAlign="start stretch">
				<p class="test-name">{{testData?.name}}</p>
			</div>
			<!-- </ng-container> -->

			<ng-container *ngIf="!testData && !sectionLoader">
				<div fxLayout="row" fxLayoutAlign="center center">
					{{locale.translate('nothing_to_show')}}
				</div>
			</ng-container>

			<ng-container *ngIf="action === 'testStart' && testData">
				<div class="take-test-body"  fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="36px"
					fxLayoutGap.xs="26px">
					<div class="total-qa-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px"
						fxLayoutGap.xs="10px">
						<div class="question-mark-info" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
							<app-chips class="total_duration"
								[data]="{title: locale.translate('duration'), value:testData?.duration + ' min'}" type="royal-capsule"
								[changeFilter]="false">
							</app-chips>
							<app-chips class="total_marks" [data]="{title: locale.translate('points'), value:testData?.totalPoints}"
								type="royal-capsule" [changeFilter]="false">
							</app-chips>
							<ng-container *ngIf="testData?.autogenerateQuestion">
								<div class="chk-block" fxLayout="row wrap" fxLayoutAlign="start center">
									<mat-icon class="check-icon">check_box</mat-icon>
									<span class="caption">{{locale.translate('auto_select_questions_at_runtime')}}</span>
								</div>
							</ng-container>
						</div>
						<!-- <div class="test-desc">Description</div> -->
						<ng-container *ngIf="testData?.description">
							<app-common-view class="caption"
								[data]="{label: locale.translate('description'), value: testData?.description}">
							</app-common-view>
						</ng-container>
					</div>
					<div class="card-block-container" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="24px">
						<ng-container *ngIf="testData?.userTestStatus?.key !== 'completed'">
							<div fxLayout="row" fxLayoutAlign="center center">
								<div fxFlex="1 1" fxFlex.xs="auto">
									<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
										<div class="warning-block" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
											<mat-icon class="warn-icon">warning</mat-icon>
											<div class="body-text">
												{{locale.translate('please_ensure_that_you_have_desc')}}</div>
										</div>
										<ng-container *ngIf="!testData?.totalQuestion">
											<div class="body-text">
												{{locale.translate('insufficient_questions_contact_the_administrator')}}
											</div>
										</ng-container>
									</div>
								</div>
							</div>
						</ng-container>
						<ng-container *ngIf="['interrupted', 'live'].includes(testData?.userTestStatus?.key)">
							<div class="resume-test" fxLayout="row" fxLayoutAlign="center center">
								<div class="retest-alert" fxFlex="0 1 500px" fxFlex.xs="auto">
									<p class="body-text">{{locale.translate('test_resume_text')}}</p>
								</div>
							</div>
						</ng-container>
					</div>
					<ng-container *ngIf="testData?.userTestStatus?.key === 'completed'">
						<div class="completion-content" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="40px">
							<div fxLayout="row" fxLayoutAlign="center center">
								<div class="completion-box" fxFlex="0 1 300px" fxFlex.xs="auto">
									<p class="body-text" fxLayoutAlign="center center">
										{{locale.translate('you_have_completed_this_test')}}
									</p>
								</div>
							</div>
							<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="30px">
								<ng-container *ngIf="![null,undefined].includes(testData?.scoredPercentage)">
									<p class="qa-text"
										[innerHtml]="locale.translate('you_have_scored') | handleBar : {'percentage': testData?.scoredPercentage}">
									</p>
								</ng-container>
							</div>
						</div>
					</ng-container>
					<ng-container *ngIf="testData?.userTestStatus?.key !== 'completed'">
						<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
							<button mat-stroked-button class="main-action-2"
								[disabled]="submitButtonDisable || testData?.totalQuestion === 0"
								(click)="takeTest()">{{(['aborted'].includes(testData?.userTestStatus?.key) ||
								!testData?.userTestStatus) ? locale.translate('start') :
								locale.translate('resume')}}</button>
						</div>
					</ng-container>
				</div>
			</ng-container>

			<ng-container *ngIf="action === 'testInprogress' && currentQuestion">
				<div class="take-test-body" fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="36px"
					fxLayoutGap.xs="26px">
					<div class="question-container" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px"
						fxLayoutGap.xs="15px">
						<loader [loader]="loader" [type]="'general'">
						</loader>
						<p class="body-text">{{locale.translate('points')}} <b>{{currentQuestion?.points}}</b></p>
						<ng-container *ngIf="![null,undefined].includes(currentQuestion?.question)">
							<p class="question" [innerHtml]="currentQuestion?.question | safeDom"></p>
						</ng-container>
						<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="22px" fxLayoutGap.xs="15px">
							<!-- <div > -->
							<mat-radio-group [(ngModel)]="currentQuestion.answer" (ngModelChange)="answerChange($event)">
								<div class="question-block" fxFlex="1 1" fxLayout="column wrap" fxLayoutAlign="space-between start">
									<ng-container
										*ngFor="let option of currentQuestion.details.options; trackBy: gfService.trackByID.bind({'key': 'index'})">
										<div class="option" fxFlex="0 1 auto" fxFlex.xs="auto" fxLayout="row" fxLayoutAlign="start center"
											fxLayoutGap="5px">
											<mat-radio-button [value]="option.index" color="primary">
												{{option?.option}}</mat-radio-button>
										</div>
									</ng-container>
								</div>
							</mat-radio-group>
							<!-- </div> -->
							<ng-container *ngIf="currentQuestion.answer">
								<mat-checkbox class="chk-icon" [(ngModel)]="currentQuestion.markForReview">
									<span class="caption">{{locale.translate('mark_for_review')}}</span>
								</mat-checkbox>
							</ng-container>
						</div>
					</div>
					<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
						<ng-container *ngIf="currentIndex !== 0 && questions?.length">
							<button mat-stroked-button class="main-action-3" [disabled]="submitButtonDisable"
								(click)="previous()">{{locale.translate('previous')}}</button>
						</ng-container>
						<ng-container *ngIf="!currentQuestion?.markForReview && !currentQuestion?.answer">
							<button mat-stroked-button class="main-action-3" [disabled]="submitButtonDisable"
								(click)="skip()">{{locale.translate('skip')}}</button>
						</ng-container>
						<ng-container *ngIf="currentQuestion?.markForReview || currentQuestion?.answer">
							<button mat-stroked-button class="main-action-2" [disabled]="submitButtonDisable"
								(click)="next()">{{locale.translate('next')}}</button>
						</ng-container>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="action === 'testEnd'">
				<div class="take-test-body" fxFlex="1 1" fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="46px"
					fxLayoutGap.xs="26px">
					<div class="completion-content" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="40px">
						<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="40px">
							<p class="body-text">{{locale.translate('you_have_reached_end_of_this_test')}}</p>
							<ng-container *ngIf="!forceToEnd">
								<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="30px">
									<ng-container
										*ngIf="![null,undefined].includes(totalAnswerCount) || ![null,undefined].includes(testData?.totalQuestion)">
										<p class="qa-text"
											[innerHtml]="locale.translate('you_have_answered_out_of_questions_text') | handleBar : {'answeredCount': totalAnswerCount, 'questionCount': testData?.totalQuestion}">
										</p>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</div>
					<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
						<ng-container *ngIf="!forceToEnd">
							<button mat-stroked-button class="main-action-3" [disabled]="submitButtonDisable"
								(click)="review()">{{locale.translate('review')}}</button>
						</ng-container>
						<button mat-stroked-button class="main-action-2" [disabled]="submitButtonDisable"
							(click)="endTest('completed')">{{locale.translate('end_test')}}</button>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="action === 'timeUp'">
				<div class="take-test-body" fxFlex="1 1" fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="46px"
					fxLayoutGap.xs="26px">
					<div class="completion-content" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="40px">
						<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="40px">
							<p class="body-text">{{locale.translate('your_time_is_up_test_has_ended')}}</p>
							<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="30px">
								<ng-container *ngIf="currentQuestion?.questionType?.key === 'mcq' &&
									![null,undefined].includes(endTestData?.scoredPercentage)">
									<p class="qa-text"
										[innerHtml]="locale.translate('you_have_scored') | handleBar : {'percentage': endTestData?.scoredPercentage}">
									</p>
								</ng-container>
								<ng-container *ngIf="currentQuestion?.questionType?.key === 'descriptive' &&
									(![null,undefined].includes(totalAnswerCount) || ![null,undefined].includes(questions?.length))">
									<p class="qa-text"
										[innerHtml]="locale.translate('you_have_answered_out_of_questions_will_be_notified_text') | handleBar : {'answeredCount': totalAnswerCount, 'questionCount': questions?.length}">
									</p>
								</ng-container>
							</div>
						</div>
					</div>
					<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
						<button mat-stroked-button class="main-action-3" [disabled]="submitButtonDisable"
							(click)="closeTest()">{{locale.translate('close')}}</button>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="action === 'testCompleted'">
				<div class="take-test-body" fxFlex="1 1" fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="36px"
					fxLayoutGap.xs="26px">
					<div class="completion-content" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="40px">
						<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="40px">
							<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="30px">
								<ng-container *ngIf="(currentQuestion?.questionType?.key === 'mcq' || !currentQuestion) &&
								![null,undefined].includes(endTestData?.scoredPercentage)">
									<p class="qa-text"
										[innerHtml]="locale.translate('you_have_scored') | handleBar : {'percentage': endTestData?.scoredPercentage}">
									</p>
								</ng-container>
								<ng-container *ngIf="currentQuestion?.questionType?.key === 'descriptive' && (![null,undefined].includes(totalAnswerCount) ||
									![null,undefined].includes(questions?.length))">
									<p class="qa-text"
										[innerHtml]="locale.translate('you_have_answered_out_of_questions_will_be_notified_text') | handleBar : {'answeredCount': totalAnswerCount, 'questionCount': questions?.length}">
									</p>
								</ng-container>
							</div>
						</div>
					</div>
					<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
						<button mat-stroked-button class="main-action-3" [disabled]="submitButtonDisable"
							(click)="closeTest()">{{locale.translate('close')}}</button>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="action === 'questions' && questions?.length">
				<div class="take-test-body" fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="36px"
					fxLayoutGap.xs="26px">
					<div class="question-list" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px"
						fxLayoutGap.xs="15px">
						<ng-container
							*ngFor="let question of questions; trackBy: gfService.trackByID.bind({'key': 'ID'}); let i = index">
							<ng-container *ngIf="question?.skipped || question?.markForReview || question?.answer">
								<div class="question-item" fxLayout="row" fxLayoutAlign="star start" fxLayoutGap="34px"
									(click)="questionNavigation(question)">
									<span class="q-type-dot"
										[ngClass]="{'skipped': question?.skipped, 'mark-review': question?.markForReview, 'answered': question?.answer}"></span>
									<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px" fxLayoutGap.xs="5px">
										<ng-container *ngIf="![null,undefined].includes(question?.question)">
											<p class="body-text" [innerHtml]="question?.question | safeDom"></p>
										</ng-container>
										<p class="body-text">{{locale.translate('points')}} {{question?.points}}</p>
									</div>
								</div>
							</ng-container>
						</ng-container>
					</div>
				</div>
			</ng-container>
		</div>

		<!---footer-->
		<ng-container *ngIf="action !== 'testStart' && testData">
			<div class="take-test-footer" fxLayout="column" fxLayoutAlign="start stretch">
				<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="36px" fxLayoutGap.xs="10px">
					<div fxFlex="1 1" fxFlex.xs="auto" class="left-block" fxLayout="row" fxLayoutAlign="start center"
						fxLayoutGap="26px" fxLayoutGap.xs="10px">
						<button class="toggle-btn" [ngClass]="{'selected': action === 'questions'}" mat-icon-button
							(click)="showQuestions()">
							<mat-icon class="toggle-icon">menu</mat-icon>
						</button>
						<ng-container *ngIf="navigationData?.length">
							<div class="question-type-container" fxFlex="0 1 400px" fxHide.xs fxLayout="row wrap"
								fxLayoutAlign="start start" fxLayoutGap="5px">
								<ng-container *ngFor="let navigation of navigationData; let i = index">
									<span class="q-type-dot" [ngClass]="navigation?.type" (click)="navigate(navigation, i)"></span>
								</ng-container>
							</div>
						</ng-container>
					</div>

					<div class="right-block" fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center"
						fxLayoutAlign.xs="space-between center" fxLayoutGap="26px" fxLayoutGap.xs="26px">
						<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px" fxLayout.xs="row"
							fxLayoutAlign.xs="start center" fxLayoutGap.xs="10px">
							<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxLayout.xs="column"
								fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="10px">
								<p class="caption" fxFlex="1 1 auto">{{locale.translate('questions')}}</p>
								<p class="entity-title">{{testData?.totalQuestion}}</p>
							</div>
							<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxLayout.xs="column"
								fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="10px">
								<p class="caption" fxFlex="1 1 auto">{{locale.translate('points')}}</p>
								<p class="entity-title">{{testData?.totalPoints}}</p>
							</div>
						</div>
						<div class="timer success"
							[ngClass]="{'success': testData.durationInSeconds, 'end': !testData.durationInSeconds}" fxLayout="row"
							fxLayoutAlign="center center" fxFlex="0 1 114px">
							<p>{{duration}}</p>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>
